import { useEffect } from "react";

const DEFAULT_TITLE = "USI Security Ltd | Manned Guarding, CCTV, K9 Patrols & Security Systems UK";
const DEFAULT_DESC = "USI Security Ltd is a UK-wide private security company providing SIA-licensed manned guarding, K9 patrols, CCTV tower hire, mobile patrols and 24/7 control room monitoring for construction sites, substations, industrial units and events.";
const SITE_URL = "https://www.usisec.co.uk";

const upsert = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attrs.tag || "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => {
    if (k === "tag") return;
    if (v == null) return;
    el.setAttribute(k, v);
  });
  return el;
};

/**
 * useSEO — sets <title>, meta description, keywords, canonical, OG and Twitter tags per route.
 */
export const useSEO = ({ title, description, keywords, path = "/", image }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | USI Security Ltd` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const url = `${SITE_URL}${path}`;
    const ogImage = image || `${SITE_URL}/og-image.jpg`;

    document.title = fullTitle;

    upsert('meta[name="description"]', { name: "description", content: desc });
    if (keywords) upsert('meta[name="keywords"]', { name: "keywords", content: keywords });
    upsert('link[rel="canonical"]', { tag: "link", rel: "canonical", href: url });

    // Open Graph
    upsert('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    upsert('meta[property="og:description"]', { property: "og:description", content: desc });
    upsert('meta[property="og:type"]', { property: "og:type", content: "website" });
    upsert('meta[property="og:url"]', { property: "og:url", content: url });
    upsert('meta[property="og:image"]', { property: "og:image", content: ogImage });
    upsert('meta[property="og:site_name"]', { property: "og:site_name", content: "USI Security Ltd" });
    upsert('meta[property="og:locale"]', { property: "og:locale", content: "en_GB" });

    // Twitter
    upsert('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsert('meta[name="twitter:title"]', { name: "twitter:title", content: fullTitle });
    upsert('meta[name="twitter:description"]', { name: "twitter:description", content: desc });
    upsert('meta[name="twitter:image"]', { name: "twitter:image", content: ogImage });
  }, [title, description, keywords, path, image]);
};
